import { render, staticRenderFns } from "./TermsofUse.vue?vue&type=template&id=eae663e4&"
import script from "./TermsofUse.vue?vue&type=script&lang=js&"
export * from "./TermsofUse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports